import { PartnerDuplicatesHeader } from 'legacy/lut/components/widgets/public/partnerDuplicates/components/partnerDuplicatesHeader/PartnerDuplicatesHeader'
import {
  IContentActions,
  IContentMessages,
  IHeaderActions,
  IHeaderMessage,
} from 'legacy/lut/components/widgets/public/partnerDuplicates/models'
import React, { FC, useMemo } from 'react'

import { IPartner, IPartnerDuplicate, TPartnerDifference } from 'clickNgo/entities/partner/models'
import { ModalDialog } from 'core-components/library/modalDialog'

import { ApolloMatchesDialogContent } from './components/apolloMatchesDialogContent/ApolloMatchesDialogContent'

interface IApolloMatchesDialogProps
  extends IHeaderActions,
    IHeaderMessage,
    IContentActions,
    IContentMessages {
  isVisible: boolean
  duplicates: IPartnerDuplicate[]
  onClose: () => void
  onSelect?: (item: IPartner) => void
  onPartialReplace?: (field: keyof IPartner, newValue: string, partner: IPartner) => void
  sortDifference?: (a: TPartnerDifference, b: TPartnerDifference) => number
}

export const ApolloMatchesDialog: FC<IApolloMatchesDialogProps> = ({
  isVisible,
  duplicates,
  onClose,
  onSelect,
  onPartialReplace,
  headerMessages,
  headerActions,
  contentActions,
  contentMessages,
  sortDifference,
}) => {
  const hasSamePartner = useMemo(
    () => duplicates && duplicates.some((partner) => partner.isSame),
    [duplicates]
  )

  const contentProps = useMemo(() => {
    return {
      duplicates,
      onSelect,
      onPartialReplace,
      contentActions,
      contentMessages,
      sortDifference,
    }
  }, [duplicates, onSelect, onPartialReplace, contentActions, contentMessages, sortDifference])

  return (
    <ModalDialog
      show={isVisible}
      closeOnOutsideClick={false}
      size="lg"
      onClose={onClose}
      header={() => (
        <PartnerDuplicatesHeader
          searchResultCount={duplicates.length}
          hasSamePartner={hasSamePartner}
          headerActions={headerActions}
          headerMessages={headerMessages}
        />
      )}
      contentProps={contentProps}
      content={ApolloMatchesDialogContent}
    />
  )
}
